/* eslint-disable flowtype/no-types-missing-file-annotation */
/* eslint-disable no-loop-func */
import type {
  Package,
  Accommodation,
  CityTour,
  CountryTreatments,
  Doctor,
  Facility,
  Treatment,
  TreatmentFAQS,
  TreatmentInfos,
  TreatmentImages
} from '../types';

export const connectIncludedData = (
  data: Package,
  included: Array<
    | Accommodation
    | CityTour
    | CountryTreatments
    | Doctor
    | Facility
    | Treatment
    | TreatmentFAQS
    | TreatmentInfos
    | TreatmentImages>
): Package => {
  included.forEach((includedObj) => {
    const { type, id, attributes } = includedObj;
    switch (type) {
      case 'country_treatment':
        // eslint-disable-next-line no-case-declarations
        const countryTreatment = data.relationships.country_treatments.data.find(
          dataObj => dataObj.id === id
        );
        if (countryTreatment) {
          countryTreatment.attributes = {
            ...(countryTreatment.attributes || {}),
            ...attributes,
          };
        }

        break;
      case 'treatment_image': {
        const treatmentImage = data.relationships.treatment_images.data.find(
          dataObj => dataObj.id === id
        );
        if (treatmentImage) {
          treatmentImage.attributes = {
            ...(treatmentImage.attributes || {}),
            ...attributes,
          };
        }
        break;
      }
      case 'treatment_info': {
        const treatmentInfo = data.relationships.treatment_infos.data.find(
          dataObj => dataObj.id === id
        );
        if (treatmentInfo) {
          treatmentInfo.attributes = {
            ...(treatmentInfo.attributes || {}),
            ...attributes,
          };
        }
        break;
      }
      case 'treatment_faq': {
        const treatmentFAQ = data.relationships.treatment_faqs.data.find(
          dataObj => dataObj.id === id
        );
        if (treatmentFAQ) {
          treatmentFAQ.attributes = {
            ...(treatmentFAQ.attributes || {}),
            ...attributes,
          };
        }
        break;
      }
      case 'doctor':
      case 'facility':
      case 'treatment':
      case 'accommodation':
      case 'city_tour': {
        const relationship = data.relationships[type];
        if (relationship && relationship.data) {
          relationship.data.attributes = {
            ...(relationship.data.attributes || {}),
            ...attributes,
          };
        }
        break;
      }
      default:
        break;
    }
  });
  return data;
};
